<template>
	<div class="modalOuter" :class="{ 'pointer-events-none': !visible }" @click="close">
		<div class="modal fade" :class="{ 'show': visible }" style="display: block;">
			<div class="modal-dialog m-0" :style="position"> <!-- translate-middle -->
				<div class="modal-content card pointer-events-none" :class="[cardType]">
					<!-- <div class="modal-header"> -->
						<!-- <h5 class="modal-title"> -->
							<!-- {{ getText('card_'+cardValue+'_title') }} -->
						<!-- </h5> -->
					<!-- </div> -->
					<div class="card-body">
						<div class="d-flex justify-content-between">
							<span class="card-title">{{ cardText('title') }}</span>
							<span class="card-title"><b-icon class="chip-icon" icon="x"></b-icon></span>
						</div>
						<div class="card-scrollable">
							<span v-if="cardType == 'reservoir'" class="card-subtitle">{{ cardText('front') }}</span>
							<span class="card-text">{{ cardText('back') }}</span>
						</div>
					</div>
					<!-- <div class="modal-body">
						<div class="text-center">
							{{ getText('card_'+cardValue+'_back') }}
						</div>
					</div> -->
					<!-- <div class="modal-footer">
						<button type="button" class="btn btn-primary">OK</button>
					</div> -->
				</div>


			</div>
		</div>
		<div class="modal-backdrop fade pointer-events-none" :style="{ 'opacity': visible ? 0.3 : 0 }"></div>
	</div>
	<!-- <b-modal
		id="modal-prevent-closing"
		ref="modal"
		:title="getText('session_short')"
		size="md"
		centered
		hide-header-close
		ok-only
		:style="{ left: '50px' }"
	>
		<div class="text-center">
			<h4 class="mb-3">Title</h4>
			<h1 class="display-4 border border-2 px-5 py-1" style="display: inline-block; border-radius: 100em;">BIG</h1>
			<p class="mt-3 mb-0">Explanation</p>
		</div>
	</b-modal> -->
</template>



<script>
	export default {
		data() {
			return {
				visible: false,
				cardType: null,
				cardValue: null,
				position: {
					left: "0px",
					top: "0px",
					// backgroundColor: "red",
					// transform: "translate(-50%, -100%) scale(0.9)",
				}
			}
		},
		mounted() {
			document.addEventListener('keydown', (event) => {
				if (event.keyCode === 27) {
					this.close();
				}
			});
		},
		methods: {
			open(cardValue, cardType, x, y) {
				this.cardValue = cardValue;
				this.cardType = cardType;

				x = Math.max(200+50, Math.min(window.innerWidth-200-50, x));
				y = Math.max(120+50, Math.min(window.innerHeight-120-50, y));
				this.position.left = `${x}px`;
				this.position.top = `${y}px`;
				this.visible = true;
				// this.$refs.modal.show();

				// this.position.transform = "translate(-50%, -100%) scale(0.9)";
				// setTimeout(() => {
					// this.position.transform = "translate(-50%, -50%) scale(1)";
				// }, 100);

				let map = localStorage.exploredCards ? JSON.parse(localStorage.exploredCards) : {};
				this.$log.onCardExplore(cardValue, !map[cardValue]);
				this.$log.onShowModal("card_info", true);
				this.$tracker.onCardExplore(cardValue, !map[cardValue]);
				map[cardValue] = true;
				localStorage.exploredCards = JSON.stringify(map);
			},
			close() {
				if (this.visible) {
					this.$log.onShowModal("card_info", false);
				}
				this.visible = false;
				// this.position.transform = "translate(-50%, -100%) scale(0.9)";
			},
			cardText(key) {
				const phrase = `card_${this.cardValue}_${key}`;
				if (this.$te(phrase)) {
					return this.$t(phrase);
				}
			},
		}
	}
</script>



<style scoped>
	.modalOuter {
		position: absolute;
		z-index: 1040;
	}

	.modalInner {
		display: block;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 1045;
		width: 100%;
		height: 100%;
		overflow-x: hidden;
		overflow-y: auto;
		outline: 0;
	}

	.modal-dialog {
		max-width: 400px !important;
		transform: translate(-50%, -50%) scale(1.0) !important;
	}

	.fade {
/*		transition: all .3s ease-in;*/
	}
	.fade:not(.show) {
		opacity: 0;
	}
	.fade:not(.show) .modal-dialog {
		transform: translate(-50%, -50%) scale(1.2) !important;
	}

	.card {
		width: 100%;
		border-radius: 0.75em;
		padding: 0.35em;
		user-select: none;
		box-shadow: 1px 4px 8px rgba(0, 0, 0, 0.3);

		font-size: 1.2em;

		/*cursor: grab;*/
	}
	.card-title, .chip-icon {
		font-size: 1.2em;
	}
	.chip-icon {
/*		width: 1.5em;*/
/*		height: 1.5em;*/
/*		margin: -1em 0;*/
/*		padding: 0;*/
	}

	.card-body {
		padding: 0.9em;
		border: 1px solid white;
		border-radius: calc(0.75em - 0.35em);

		display: -webkit-box;
		flex-direction: column;
		justify-content: center;
		overflow: auto;

		background-color: white;
		font-size: 0.9em;
		text-align: left;
	}

	.card-scrollable {
		display: flex;
		flex-direction: column;
		overflow-y: auto;
	}

	.card-title {
		font-weight: bold;
	}

	.card-subtitle {
		margin-bottom: 0.7em;
	}
</style>
